export default {"src":"/_next/static/media/SAVA.42860ad4.svg","height":18,"width":18};